import { useApi } from '../../api/api-context';
import { useQueryMutation } from '../../api/use-query-mutation';
import { useBudgetId } from '../../budget/budget-store';
import { useHistoryStore } from '../../history/history-store';
import { useQueryClient } from '@tanstack/react-query';
import { logAndThrowError } from '../../utils/errors';
export const useUpdateCategoryApi = (options) => {
    const api = useApi();
    const budgetId = useBudgetId();
    const queryClient = useQueryClient();
    const queryKey = ['categories', budgetId];
    const historyStore = useHistoryStore();
    const updateCategoryApi = async (data) => {
        await api.put('/category', data);
    };
    const onMutate = (oldData, request) => {
        if (!oldData) {
            logAndThrowError('No categories data found');
        }
        const categoryIndex = oldData.findIndex((category) => category.id === request.id);
        if (categoryIndex === -1) {
            logAndThrowError('Category not found');
        }
        const newData = [...oldData];
        newData[categoryIndex] = {
            ...oldData[categoryIndex],
            ...request,
        };
        return newData;
    };
    const { mutate, isPending } = useQueryMutation(updateCategoryApi, queryKey, onMutate, options);
    // Wrap the mutate function to add history tracking
    const mutateWithHistory = async (request) => {
        // Get the original category before mutation
        const oldCategory = queryClient.getQueryData(queryKey)?.find((category) => category.id === request.id);
        // Perform the mutation
        mutate(request);
        // Push the history event
        historyStore.pushEvent({
            description: `Update Category`,
            undo: () => {
                // Call the same mutation with the old data
                if (oldCategory) {
                    mutate(oldCategory);
                }
            },
            redo: () => {
                // Replay the original mutation
                mutate(request);
            },
        });
    };
    return {
        mutate: mutateWithHistory,
        isPending,
    };
};
